export default __webpack_public_path__ + "static/media/camera_light.069f8c4d.png";